import React, { useState } from 'react';
import DocumentStepBar from './DocumentStepBar';
import './style.scss';
import DocumentForm from './DocumentForm';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const DocumentSubmissionForm = (props) => {
  const [activeStep, setActiveStep] = useState(1);
  const TOTAL_STEPS = 3;
  const steps = [
    { number: 1, title: props.t('DocumentDetails'), descriptions: props.t('SteponeDescription') },
    { number: 2, title: props.t('DocumentUpload'), descriptions: props.t('StepTwoDescription') },
    { number: 3, title: props.t('Verification'), descriptions: props.t('StepThreeDescription') },
  ];

  // Calculate progress percentage
  const progress = ((activeStep - 1) / (TOTAL_STEPS - 1)) * 100;

  return (
    <div className="DocumentContainer">
      <div className="document_left_side">
        <DocumentStepBar activeStep={activeStep} t={props.t} steps={steps}>
          <div className="DesktopProgressBar">
            <div className="ProgressText">
              <span>{props.t('TotalProgress')}</span>
              <div>({Math.round(progress)}%)</div>
            </div>
            <div className="ProgressTrack">
              <div className="ProgressFill" style={{ width: `${progress}%` }} />
            </div>
          </div>
        </DocumentStepBar>
      </div>
      <div className="document_right_side">
        <DocumentForm
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          t={props.t}
          ExtensionLimitDetailsEndpoint={props?.fields?.ExtensionLimitDetailsEndpoint?.value}
          ExtraUserDetailsEndpoint={props?.fields?.ExtraUserDetailsEndpoint?.value}
          IsMockExtraUserDetailsEndpoint={props?.fields?.IsMockExtraUserDetailsEndpoint?.value}
          GenerateOTPEndpoint={props?.fields?.GenerateOTPEndpoint?.value}
          IsMockGenerateOTPEndpoint={props?.fields?.IsMockGenerateOTPEndpoint?.value}
          VerifyOTPEndpoint={props?.fields?.VerifyOTPEndpoint?.value}
          IsMockVerifyOTPEndpoint={props?.fields?.IsMockVerifyOTPEndpoint?.value}
          DocumentSubmissionEndpoint={props?.fields?.DocumentSubmissionEndpoint?.value}
          limitationNumber={props?.fields?.limitationNumber?.value}
          limitationMessage={props?.fields?.limitationMessage?.value}
          timeoutErrorMessage = {props?.fields?.timeoutErrorMessage?.value}
          verificationCodeExpiredErrorMessage = {props?.fields?.verificationCodeExpiredErrorMessage?.value}
          timeout = {props?.fields?.timeout?.value}
          otpVerificationCode = {props?.fields?.otpVerificationCode?.value}
          otpDidNotReceiveText = {props?.fields?.otpDidNotReceiveText?.value}
          otpSendNewCodeText = {props?.fields?.otpSendNewCodeText?.value}
        />

        <div className="MobileProgressBar">
          <div className="ProgressText">
            <span>{props.t('TotalProgress')}</span>
            <div>({Math.round(progress)}%)</div>
          </div>
          <div className="ProgressTrack">
            <div className="ProgressFill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(DocumentSubmissionForm));
